import _extends from "@babel/runtime/helpers/extends";
var _DomainActionsErrorsM, _DomainActionsErrorsM2, _DomainActionsErrorsM3;
import { Box } from '@wix/design-system';
import { DomainActionsErrorsMap, DomainSearchSuiteModule, SearchRecommendationModule } from '@wix/domains-search-suite';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import React from 'react';
import { GeneralAnonymousOverride, SubdomainRootTaken } from '../../../Components';
import { AnonymousFooter } from '../../../Components/AnonymousFooter/AnonymousFooter';
import { AnonymousResultsHeader } from '../../../Components/Headers';
import { BackButton } from '../../../Components/Headers/HeaderWrapper';
import { AnonymousVoucherBanner } from '../../../Components/VoucherBanner';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { useIsWixHpReferral } from '../../../hooks/useIsWixHpReferral';
import { useRecommendations } from '../../../hooks/useRecommendations';
import { useResultsBack } from '../../../hooks/useResultsBack';
import { useSettledMethods } from '../../../hooks/useSettledMethod';
import { ANONYMOUS_SETTLEMENTS } from '../../../utils/anonymousSettlements';
import { ResultsLayout, ResultsRecommendations, ResultsSearchBar } from '../../ResultsLayout';
import { ExperimentSpecs } from '../../../constants';
import { DeclaredExperimentsProvider } from '../../../hooks/declaredExperiments';
import { usePerceptionEnabled, usePerceptionPricing } from '../../../pricingPerception';
import s from '../../anonymousResultsPage.scss';
const customConfiguration = {
  ...(((_DomainActionsErrorsM = DomainActionsErrorsMap.connect) == null ? void 0 : _DomainActionsErrorsM.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  ...(((_DomainActionsErrorsM2 = DomainActionsErrorsMap.assign) == null ? void 0 : _DomainActionsErrorsM2.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  ...(((_DomainActionsErrorsM3 = DomainActionsErrorsMap.transfer) == null ? void 0 : _DomainActionsErrorsM3.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  transfer: GeneralAnonymousOverride,
  connect: GeneralAnonymousOverride,
  subdomainRootIsNotConnected: SubdomainRootTaken,
  domainTakenInWix: GeneralAnonymousOverride,
  subdomainTakenInWix: SubdomainRootTaken,
  noStatus: GeneralAnonymousOverride
};
export const AnonymousResultsPage = _ref => {
  let {
    handlers,
    externalViewer,
    deviceType,
    showCartHeader
  } = _ref;
  useSettledMethods(ANONYMOUS_SETTLEMENTS);
  // Declared here rather than in the content component: the pricing call happens inside
  // ResultsLayout, which Content renders.
  const perceptionEnabled = usePerceptionEnabled();
  const experimentIds = perceptionEnabled ? [ExperimentSpecs.PricingPerceptionFirstYear] : [];
  return /*#__PURE__*/React.createElement(DomainsApiClient.Provider, null, /*#__PURE__*/React.createElement(DeclaredExperimentsProvider, {
    ids: experimentIds
  }, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      },
      handlers
    },
    statusesCustomComponents: {
      customConfiguration
    }
  }, /*#__PURE__*/React.createElement(AnonymousResultsPageContent, {
    deviceType: deviceType,
    showCartHeader: showCartHeader
  }))));
};
export const AnonymousResultsPageContent = _ref2 => {
  let {
    deviceType,
    showCartHeader = false
  } = _ref2;
  const isMobile = useIsMobile();
  const isWixHpReferral = useIsWixHpReferral();
  const isWixHpMobile = isMobile && isWixHpReferral;
  const handleBackClick = useResultsBack();
  const {
    taxesNotIncluded
  } = useRecommendations({
    enableOnEmptyQuery: false
  });
  const {
    heroLayouts,
    ...perceptionPricing
  } = usePerceptionPricing();
  return /*#__PURE__*/React.createElement(ResultsLayout, {
    biViewMode: "Storefront",
    querySubmitPath: "/",
    deviceType: deviceType,
    showCartHeader: showCartHeader,
    isResultsPageOptimizations: true,
    searchBar: /*#__PURE__*/React.createElement(ResultsSearchBar, {
      isWixHpMobile: isWixHpMobile
    }),
    header: /*#__PURE__*/React.createElement(AnonymousResultsHeader, {
      onBackClick: isMobile ? undefined : handleBackClick,
      isResultsPageOptimizations: true
    }),
    voucher: /*#__PURE__*/React.createElement(AnonymousVoucherBanner, {
      isResultsPageOptimizations: true
    }),
    footer: /*#__PURE__*/React.createElement(Box, {
      gridArea: "footer",
      padding: "SP6 48px",
      className: s.centeredContent,
      textAlign: "center",
      align: "center"
    }, /*#__PURE__*/React.createElement(AnonymousFooter, {
      taxesNotIncluded: taxesNotIncluded
    })),
    mobileBackButton: isWixHpMobile ? undefined : /*#__PURE__*/React.createElement(Box, {
      width: "100%"
    }, /*#__PURE__*/React.createElement(BackButton, {
      onClick: handleBackClick
    }))
  }, /*#__PURE__*/React.createElement(SearchRecommendationModule.Provider, {
    Layouts: {
      customConfiguration: heroLayouts ?? {}
    }
  }, /*#__PURE__*/React.createElement(ResultsRecommendations, _extends({
    showHeroCard: true,
    className: s.centeredContent,
    emptyState: isWixHpMobile ? /*#__PURE__*/React.createElement(React.Fragment, null) : undefined
  }, perceptionPricing))));
};
//# sourceMappingURL=AnonymousResultsPage.js.map